import { Center, Spinner, useDisclosure } from '@chakra-ui/react';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  useFetchOrderDetailQuery,
} from 'rtkQuery/sharespro/queries/orders';

import OrderDetailLoaded from 'presentation/components/modules/orders/detail/OrderDetailLoaded';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import OrderConfirmationModal from 'presentation/containers/modules/orders/OrderConfirmationModal';
import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import CancelOrderModal from 'presentation/containers/modules/orders/CancelOrderModal';

const OrderDetailPage: FC = () => {
  const { id } = useParams();

  const { data, isFetching, error, refetch } = useFetchOrderDetailQuery(
    +(id as string)
  );

  const { t } = useTranslation();

  const {
    isOpen: isConfirmationModalOpen,
    onOpen: openConfirmationModal,
    onClose: closeConfirmationModal,
  } = useDisclosure();

  const {
    isOpen: isCancelOrderModalOpen,
    onOpen: openCancelOrderModal,
    onClose: closeCancelOrderModal,
  } = useDisclosure();

  let content;
  let wrapByCard = true;
  if (isFetching) {
    content = <Spinner />;
  } else if (data) {
    wrapByCard = false;
    content = (
      <>
        <OrderConfirmationModal
          isOpen={isConfirmationModalOpen}
          onClose={closeConfirmationModal}
          orderId={data.id}
        />
        <CancelOrderModal
          isOpen={isCancelOrderModalOpen}
          onClose={closeCancelOrderModal}
          orderId={data.id}
        />
        <OrderDetailLoaded
          onOrderConfirmClick={() => {
            openConfirmationModal();
          }}
          {...data}
          onOrderCancelClick={() => {
            openCancelOrderModal();
          }}
        />
      </>
    );
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (wrapByCard) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <ActivesPageLayout>
      <Helmet>{data?.name && <title>{data.name}</title>}</Helmet>
      <GridHeading>{t('recommendationNumber', { id })}</GridHeading>
      {content}
    </ActivesPageLayout>
  );
};

export default OrderDetailPage;
